export default __webpack_public_path__ + "static/media/BlackCasper.46e87d47.ttf";